import { render, staticRenderFns } from "./AssignFreightOrderComponent.vue?vue&type=template&id=384ff77b&"
import script from "./AssignFreightOrderComponent.vue?vue&type=script&lang=js&"
export * from "./AssignFreightOrderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports